import { Button, InputLabel, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { snackbarRef } from "../../../App";
import { APP_ICONS, APP_LOGO } from "../../../assets";
import AuthContainer from "../../../components/containers/AuthContainer";
import Loader from "../../../components/loader";
import TextInput from "../../../components/textInput";
import { setUserData } from "../../../redux/slices/Login";
import { adminLogin } from "../../../services/Auth";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { constants } from "../../../theme/Variables";

const LoginPage = () => {
  const [showPass, setShowPass] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [inputVall, setInputVall] = useState({
    email: "",
    password: "",
  });

  const handleOpenSnackBar = (type, message) => {
    constants.snackRef.isOpenSnack({
      snackType: type,
      snackMessage: message,
    });
  };

  const handleChangeInput = (key, value) => {
    setInputVall((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleLogin = async () => {
    try {
      const payload = {
        email: inputVall.email,
        password: inputVall.password,
      };
      setIsLoading(true);
      const response = await adminLogin(payload);
      setIsLoading(false);

      if (response.status === 200 || response.status === 201) {
        const data = response?.data?.data;
        console.log(data, "datadatadatadata");
        dispatch(setUserData(data?.userDetails));
        localStorage.setItem("user", JSON.stringify(data?.userDetails));
        localStorage.setItem("token", JSON.stringify(data?.toker));

        navigate("/");
        handleOpenSnackBar("success", "Login successful!");
      } else {
        handleOpenSnackBar("error", response?.data?.message || "Login failed.");
      }
    } catch (error) {
      setIsLoading(false);
      handleOpenSnackBar(
        "error",
        error?.message || "An error occurred while logging in."
      );
    }
  };

  return (
    <AuthContainer>
      <Stack alignItems={"center"}>
        <img src={APP_LOGO.appLogo} width={177} alt="App Logo" />
      </Stack>
      <Typography
        my={2}
        fontSize={"1.5rem"}
        fontWeight={600}
        textAlign={"center"}
      >
        Welcome To BB Life Dashboard!
      </Typography>

      <Grid container rowSpacing={2} mt={4}>
        <Grid size={12}>
          <InputLabel className={"input-label"}>Email</InputLabel>
          <TextInput
            value={inputVall.email}
            onChange={(e) => handleChangeInput("email", e.target.value)}
          />
        </Grid>
        <Grid size={12}>
          <InputLabel className={"input-label"}>Password</InputLabel>
          <TextInput
            type={showPass ? "text" : "password"}
            value={inputVall.password}
            InputEndIcon={showPass ? <VisibilityIcon /> : <VisibilityOffIcon />}
            onEndIconClick={() => setShowPass(!showPass)}
            onChange={(e) => handleChangeInput("password", e.target.value)}
          />
        </Grid>
      </Grid>

      <Stack
        my={3}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"flex-end"}
        gap={0.5}
      >
        <Link className="forgot-link" to={"/forgot-password"}>
          Forgot Password
        </Link>
        <img src={APP_ICONS.questionIcon} width={16} alt="Help Icon" />
      </Stack>

      <Button
        variant="contained"
        onClick={handleLogin}
        sx={{
          mt: 1,
          height: 45,
        }}
      >
        Login
      </Button>
      <Loader isloading={isLoading} />
    </AuthContainer>
  );
};

export default LoginPage;
